/**
 * @generated SignedSource<<c3694468fac531b938f1be841c5fc82e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CampaignFilterScreenQuery$variables = {};
export type CampaignFilterScreenQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CampaignFilter">;
};
export type CampaignFilterScreenQuery = {
  response: CampaignFilterScreenQuery$data;
  variables: CampaignFilterScreenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "CampaignFilterScreenQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "CampaignFilter"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "CampaignFilterScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MCategory",
        "kind": "LinkedField",
        "name": "mCategories",
        "plural": true,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "keyName",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "MPrefecture",
        "kind": "LinkedField",
        "name": "prefectures",
        "plural": true,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "regionName",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "21047bb70edb0ff8418a55c2a31bff0d",
    "id": null,
    "metadata": {},
    "name": "CampaignFilterScreenQuery",
    "operationKind": "query",
    "text": "query CampaignFilterScreenQuery {\n  ...CampaignFilter\n}\n\nfragment CampaignFilter on Query {\n  mCategories {\n    id\n    name\n    keyName\n  }\n  prefectures {\n    id\n    name\n    regionName\n  }\n}\n"
  }
};
})();

(node as any).hash = "a165eeb0f6274043524f4d0aa760020e";

export default node;
